const cardText = {
  fontSize: { xs: '10px', sm: '16px' },
  fontWeight: 400,
  lineHeight: { xs: '12px', sm: '20px' },
  letterSpacing: '0px',
  textAlign: { xs: 'center', sm: 'left' },
  color: '#D1D1D1',
  pt: { xs: '7px', sm: '16.5px' },
  width: { xs: '94%', sm: 'auto' },
  mb: { xs: '-4px', sm: 0 },
};

export const sxStyle = {
  cardBox: {
    border: '1px solid #D1D1D1',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: { xs: '84px', sm: '140px' },
    height: { xs: '78px', sm: '120px' },
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },

  cardBoxSelected: theme => ({
    ...sxStyle.cardBox,
    backgroundColor: theme.tertiary,
  }),

  cardText,
  cardTextSelected: {
    ...cardText,
    color: '#FFFFFF',
  },
};
